export default __webpack_public_path__ + "static/media/91.9a8be8fe.png";